import kaplay from "kaplay";
import { gameScene } from "./game-scene";
import { dialogScene } from "./dialog-scene";
import { menuScene } from "./menu-scene";
import { creditScene } from "./credit-scene";
import { playerSprite } from "./player-scene";

const k = kaplay({
  width: 1920,
  height: 1080,
  buttons: {
    next: {
      keyboard: "space",
      mouse: "left",
    },
    upButton: {
      keyboard: ["w", "up"],
      gamepad: ["dpad-up"] // You can also bind "leftstick-up" if supported
    },
    downButton: {
      keyboard: ["s", "down"],
      gamepad: ["dpad-down"]
    },
    leftButton: {
      keyboard: ["a", "left"],
      gamepad: ["dpad-left"]
    },
    rightButton: {
      keyboard: ["d", "right"],
      gamepad: ["dpad-right"]
    },
    aButton: {
      keyboard: ["space"],
      gamepad: ["south", "ltrigger", "rtrigger"]
    }
  }
});

k.loadRoot("./"); // A good idea for Itch.io publishing later

// dialogScene(k)
// k.go("dialog-scene")

// menuScene(k)
// k.go("menu-scene")


gameScene(k)
k.go("game-scene")


// creditScene(k)
// k.go("credit-scene")

